import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function PromoBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (isDismissed) return;
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      // Calculate scroll percentage
      const scrollPercentage = scrollPosition / (documentHeight - windowHeight);
      // Show banner when scrolled past 70%
      if (scrollPercentage > 0.7 && !isVisible) {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    // Check initially in case the page is already scrolled
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed, isVisible]);
  return <AnimatePresence data-id="element-222">
      {isVisible && !isDismissed && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:w-[380px] bg-white border border-line rounded-[2rem] shadow-2xl z-50 p-8 flex flex-col gap-4" data-id="element-223">
          <button onClick={() => setIsDismissed(true)} className="absolute top-6 right-6 text-muted hover:text-ink transition-colors bg-surface p-1.5 rounded-full" aria-label="Закрити" data-id="element-224">
            <X size={16} strokeWidth={2} data-id="element-225" />
          </button>

          <p className="text-sm text-ink font-normal leading-relaxed pr-8" data-id="element-226">
            Створюємо сучасні сайти{' '}
            <span className="font-semibold" data-id="element-227">БЕЗКОШТОВНО</span>, обслуговування
            всього 650 грн / місяць.
          </p>

          <div className="flex flex-col gap-4 mt-2 pt-6 border-t border-line" data-id="element-228">
            <a href="https://jetly.agency/ua/sale" target="_blank" rel="noreferrer" className="text-xs font-semibold tracking-widest uppercase text-muted hover:text-ink transition-colors" data-id="element-229">
              Дізнатися більше
            </a>
            <a href="tel:+380502276199" className="text-xs font-semibold tracking-widest uppercase text-ink hover:text-muted transition-colors" data-id="element-230">
              +38 050 227 61 99
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}